import axios from "axios";
import { MtbqParam } from "./types/MtbqParam";
import { LatLong } from "./types/LatLong";
import { LatLonParam } from "./types/LatLonParam";
import { UploadParam } from "./types/UploadParam";
import { GetMyFundeParam } from "./types/GetMyFundeParam";
import { FundDetailsDTO } from "./types/FundDetailsDTO";
import { RejectParam } from "./types/RejectParam";
import { ApproveParam } from "./types/ApproveParam";
import { correctDates } from "./helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class ExpertController {

  public static async MtbqToLatLon(p: MtbqParam): Promise<LatLong> {
    const result = await axios.post(mapUrl("Expert/MtbqToLatLon"), p);
    return correctDates(result.data);
  }

  public static async LatLonToMtbq(latlon: LatLonParam): Promise<string> {
    const result = await axios.post(mapUrl("Expert/LatLonToMtbq"), latlon);
    return correctDates(result.data);
  }

  public static async Upload(p: UploadParam): Promise<number> {
    const result = await axios.post(mapUrl("Expert/Upload"), p);
    return correctDates(result.data);
  }

  public static async GetMyFunde(p: GetMyFundeParam): Promise<FundDetailsDTO[]> {
    const result = await axios.post(mapUrl("Expert/GetMyFunde"), p);
    return correctDates(result.data);
  }

  public static async GetPendingCount(): Promise<number> {
    const result = await axios.post(mapUrl("Expert/GetPendingCount"), );
    return correctDates(result.data);
  }

  public static async GetPendingFunde(): Promise<FundDetailsDTO[]> {
    const result = await axios.post(mapUrl("Expert/GetPendingFunde"), );
    return correctDates(result.data);
  }

  public static async Reject(p: RejectParam): Promise<void> {
    const result = await axios.post(mapUrl("Expert/Reject"), p);
    return correctDates(result.data);
  }

  public static async Approve(p: ApproveParam): Promise<void> {
    const result = await axios.post(mapUrl("Expert/Approve"), p);
    return correctDates(result.data);
  }

  public static async getGemeinde(p: LatLonParam): Promise<string[]> {
    const result = await axios.post(mapUrl("Expert/getGemeinde"), p);
    return correctDates(result.data);
  }

}
